import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/common.css'
import './assets/js/flexible'

createApp(App).mount('#app')
